module.exports = __webpack_public_path__ + "je.9b525d73886995a1c598.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/je.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/je.svg
// module chunks = styles